import { ActCode } from './ActCode';
import { RequiredDetails } from '../requiredDetail.type';
import dateHospitalisation from '../DateHospitalisation/dateHospitalisation';
import multiDiagnostic from '../MultipleDiagnostic/multipleDiagnostic';
import endTimeIfMoreThan60Min from '../EndTimeIfMoreThan60Min/endTimeIfMoreThan60Min';
import intensiveCareExceptionalCircumstances from '../ExceptionalCircumstances/intensiveCareExceptionalCircumstances';
import HOSPITAL_ACTIVITY_AREA_MAP from '../../../../shared/ramq/domainValues/activityAreas';
import referenceProfessional from '../ReferenceProfessional/referenceProfessional';

export default class ActCode36 implements ActCode {
  // eslint-disable-next-line no-unused-vars
  constructor(private act: any) {}

  getRequiredDetails(): RequiredDetails {
    const requiredDetails = [dateHospitalisation, referenceProfessional, multiDiagnostic, endTimeIfMoreThan60Min];

    if (this.act.activityArea === HOSPITAL_ACTIVITY_AREA_MAP.intensiveCareUnit) {
      requiredDetails.push(intensiveCareExceptionalCircumstances);
    }

    return requiredDetails;
  }
}
